var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images-list"},_vm._l((_vm.images),function(image,index){return _c('van-image',{key:index,attrs:{"src":image.url,"lazy-load":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }